// extracted by mini-css-extract-plugin
export var inline = "_vg-0";